import React from "react";
import { ShoppingGallery } from "./fabric-shopping-gallery";
import FabricFiltersBar from "./fabric-filters-bar";
import SortBar from "./sort-bar";
import { cloneData } from "../../../library/utils/clone";
import { sortByProperty } from "../../functions/sort-by-property";
import { InfiniteScrollComponent } from "../../../library/components/components";
import LoadingIndicator from "../loading/loading-indicator";
import GallerySearchBar from "./gallery-search-bar";
import { parseFiltersFromUrl, writeFiltersToUrl, subscribePopstate, normalizeArray } from "../../functions/filter-url-state";

// URL ↔ filter state mapping for the Fabric / Leather / Vinyl-Faux / Trim
// galleries (all share fabric-filters-bar + fabric-gallery).
var URL_SCHEMA = {
    collections: 'array', patterns: 'array', colors: 'array', grades: 'array',
    statuses: 'array',
    stockMin: 'number', stockMax: 'number',
    sort: 'string', find: 'string'
};
var DEFAULT_SORT = "sku|ASC";
// Code-style status values used in the FabricFiltersBar STATUS_OPTIONS.
var STATUS_CANONICAL = ['inStock', 'performance', 'commercialGrade'];

function urlToFilterBarState(u) {
    if (!u) return null;
    var hasAny = false;
    var out = {
        stock: {}, status: [], collections: [], patterns: [], colors: [], grades: []
    };
    if (u.collections) { out.collections = u.collections; hasAny = true; }
    if (u.patterns)    { out.patterns    = u.patterns;    hasAny = true; }
    if (u.colors)      { out.colors      = u.colors;      hasAny = true; }
    if (u.grades)      { out.grades      = u.grades;      hasAny = true; }
    if (u.statuses)    { out.status      = u.statuses;    hasAny = true; }
    if (u.stockMin != null) { out.stock.stockMin = u.stockMin; hasAny = true; }
    if (u.stockMax != null) { out.stock.stockMax = u.stockMax; hasAny = true; }
    return hasAny ? out : null;
}

function filterBarStateToUrl(s) {
    if (!s) return {};
    var out = {
        collections: s.collections, patterns: s.patterns, colors: s.colors,
        grades: s.grades, statuses: s.status
    };
    if (s.stock && s.stock.stockMin != null) out.stockMin = s.stock.stockMin;
    if (s.stock && s.stock.stockMax != null) out.stockMax = s.stock.stockMax;
    return out;
}

function normalizeUrlState(parsed, serverFilters) {
    if (!parsed) return parsed;
    var f = serverFilters || {};
    if (parsed.collections) parsed.collections = normalizeArray(parsed.collections, f.collections);
    if (parsed.patterns)    parsed.patterns    = normalizeArray(parsed.patterns,    f.patterns);
    if (parsed.colors)      parsed.colors      = normalizeArray(parsed.colors,      f.colors);
    if (parsed.grades)      parsed.grades      = normalizeArray(parsed.grades,      f.grades);
    if (parsed.statuses)    parsed.statuses    = normalizeArray(parsed.statuses,    STATUS_CANONICAL);
    return parsed;
}

function stockMatchesRange(stockValue, range) {
    if (stockValue == null) return false;
    if (range.stockMin != null && stockValue < range.stockMin) return false;
    if (range.stockMax != null && stockValue > range.stockMax) return false;
    return true;
}

// Shared filter predicate.
function productMatchesFilters(product, f) {
    if (f.patterns && f.patterns.length) {
        var okPattern = false;
        for (var i = 0; i < f.patterns.length; i++) {
            if ((product.patternGroup || []).indexOf(f.patterns[i]) !== -1) { okPattern = true; break; }
        }
        if (!okPattern) return false;
    }
    if (f.collections && f.collections.length) {
        if (f.collections.indexOf(product.collection || "") === -1) return false;
    }
    if (f.grades && f.grades.length) {
        // Gallery items carry a single `grade` string (FabricGalleryModel.Grade),
        // not a `grades` array — compare against the selected values directly.
        var okGrades = false;
        var productGrade = (product.grade || "").trim();
        for (var j = 0; j < f.grades.length; j++) {
            if (productGrade === String(f.grades[j]).trim()) { okGrades = true; break; }
        }
        if (!okGrades) return false;
    }
    if (f.colors && f.colors.length) {
        var okColors = false;
        var productColor = product.colorGroup || "";
        for (var k = 0; k < f.colors.length; k++) {
            if (productColor === f.colors[k]) { okColors = true; break; }
        }
        if (!okColors) return false;
    }
    if (f.status && f.status.length) {
        var okStatus = false;
        for (var q = 0; q < f.status.length; q++) {
            var val = f.status[q];
            if (val === "inStock" && product.inStock === true) { okStatus = true; break; }
            if (val === "performance" && product.isPerformance === true) { okStatus = true; break; }
            if (val === "commercialGrade" && product.isCommercialGrade === true) { okStatus = true; break; }
        }
        if (!okStatus) return false;
    }
    if (f.stock && (f.stock.stockMin != null || f.stock.stockMax != null)) {
        if (!stockMatchesRange(product.stockValue, f.stock)) return false;
    }
    return true;
}


class Gallery extends React.Component {
    constructor(props) {
        super(props);
        this.state = { mobileFilterOpen: false };
    }

    openMobileFilter = () => { this.setState({ mobileFilterOpen: true }); };
    closeMobileFilter = () => { this.setState({ mobileFilterOpen: false }); };

    render() {
        let data = this.props.data;
        let count = data.length;
        let countLabel = count === 1 ? "item" : "items";
        let displayCount = this.props.pagedData.length;
        return (
            <div>
                <div className="gallery-grid" ref={(ref) => this.galleryGrid = ref}>
                    <div className="gallery-filters-container">

                    </div>
                    <div className="gallery-items-container">
                        <div className="filters-header-container">
                            <div className="filters-bar-small-screen">
                                <span onClick={this.openMobileFilter}>Filter</span>
                            </div>
                            <div className={"filters-bar-container" + (this.state.mobileFilterOpen ? " mobile-open" : "")}>
                                <div className="mobile-filter-header">
                                    <span className="mobile-filter-title">FILTER/SORT</span>
                                    <button type="button" className="mobile-filter-close" onClick={this.closeMobileFilter}>×</button>
                                </div>
                                <div className="mobile-filter-body">
                                    {this.props.children}
                                    <span className="sort-bar-mobile-only">
                                        <SortBar
                                            key={"sbm-" + (this.props.urlVersion || 0)}
                                            onSortChange={this.props.onSortChange}
                                            excludePriceSort={true}
                                            defaultSort={this.props.currentSort || "sku|ASC"}
                                        />
                                    </span>
                                </div>
                                <div className="mobile-filter-footer">
                                    <span className="mobile-filter-count">{count} {count === 1 ? "Piece" : "Pieces"}</span>
                                    <button type="button" className="mobile-filter-apply" onClick={this.closeMobileFilter}>APPLY</button>
                                </div>
                            </div>
                            {this.state.mobileFilterOpen && <div className="mobile-filter-overlay" onClick={this.closeMobileFilter}></div>}
                            <div className="gallery-items-count">
                                <GallerySearchBar
                                    key={"gsb-" + (this.props.urlVersion || 0)}
                                    onSubmitSearch={this.props.onSubmitSearch}
                                    initialValue={this.props.searchTerm || ""}
                                />
                                <span className="sort-bar-desktop-only">
                                    <SortBar
                                        key={"sbd-" + (this.props.urlVersion || 0)}
                                        onSortChange={this.props.onSortChange}
                                        excludePriceSort={true}
                                        defaultSort={this.props.currentSort || "sku|ASC"}
                                    />
                                </span>
                                <span className="count-label">{displayCount}&nbsp;of&nbsp;{count}&nbsp;{countLabel}</span>

                            </div>
                        </div>
                        <div className="gallery-items-list">
                            <ShoppingGallery
                                data={this.props.pagedData}
                                baseImageUrl={this.props.baseImageUrl}
                                onLike={this.props.onLike}
                                location={this.props.location}
                            />
                            {count < 1 &&
                                <div className="gallery-no-results">
                                    No items match your filter criteria. Please adjust your filters and try again.
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {this.props.showLoader &&
                    <LoadingIndicator />
                }
            </div>  
            
        );

    }
}

class BaseGalleryComponent extends InfiniteScrollComponent {
    constructor(props) {
        super(props)
        this.yBottom = 500;
        let data = props.data || [];
        data = sortByProperty(data, "sku", "ASC");
        let dataCopy = cloneData(data);
        data=this.filterDataByIndustry(data,props.industry);
        let N=100;
        let pagedData=data.slice(0,N);
        this.throttleScroll = false;
        this.state = {
            pagedData:pagedData,
            page:1,
            N:N,
            maxPage:this.maxPage(data,N),
            originalMaxPage:this.maxPage(data,N),
            data: data,
            filteredDataCopy:data,
            dataCopy: dataCopy,
            sortBy: DEFAULT_SORT,
            showLoader: false,
            searchTerm:'',
            urlVersion: 0,
            initialFilterBarState: null
        }
        this._currentFilterBarState = null;
    }

    componentDidMount() {
        super.componentDidMount();
        this.toast = document.querySelector("paper-toast");
        this.galleryGrid = document.querySelector(".gallery-grid");
        this.applyUrlState();
        this._popstateUnsub = subscribePopstate(this.onPopstate);
    }

    componentWillUnmount() {
        if (typeof super.componentWillUnmount === 'function') super.componentWillUnmount();
        if (this._popstateUnsub) { this._popstateUnsub(); this._popstateUnsub = null; }
    }

    onPopstate = () => { this.applyUrlState({ bumpVersion: true }); }

    applyUrlState = (opts) => {
        var parsed = parseFiltersFromUrl(URL_SCHEMA);
        parsed = normalizeUrlState(parsed, this.props.filters);
        var filterState = urlToFilterBarState(parsed);
        var sortBy = parsed.sort || null;
        var find = parsed.find || '';

        if (!filterState && !sortBy && !find) {
            if (opts && opts.bumpVersion) {
                this.setState({ urlVersion: (this.state.urlVersion || 0) + 1 });
            }
            return;
        }

        this._currentFilterBarState = filterState;

        var filtered = (this.state.dataCopy || []).slice();
        if (this.props.industry) filtered = this.filterDataByIndustry(filtered, this.props.industry);
        if (filterState) {
            filtered = filtered.filter(function (p) { return productMatchesFilters(p, filterState); });
        }
        var activeSort = sortBy || this.state.sortBy || DEFAULT_SORT;
        filtered = this.sortData(filtered, activeSort);

        var filteredDataCopy = cloneData(filtered);
        if (find) {
            var self = this;
            filtered = filtered.filter(function (p) { return self.matchesSearch(p, find); });
        }

        var paged = filtered.slice(0, this.state.N);
        var nextState = {
            pagedData: paged,
            data: filtered,
            filteredDataCopy: filteredDataCopy,
            page: 1,
            maxPage: this.maxPage(filtered, this.state.N),
            sortBy: activeSort,
            searchTerm: find,
            initialFilterBarState: filterState
        };
        if (opts && opts.bumpVersion) {
            nextState.urlVersion = (this.state.urlVersion || 0) + 1;
        } else if (filterState || find || sortBy) {
            nextState.urlVersion = (this.state.urlVersion || 0) + 1;
        }
        this.setState(nextState);
    }

    syncUrl = (overrides) => {
        var sortBy = (overrides && overrides.sortBy != null) ? overrides.sortBy : (this.state.sortBy || DEFAULT_SORT);
        var searchTerm = (overrides && typeof overrides.searchTerm === 'string') ? overrides.searchTerm : (this.state.searchTerm || '');
        var filterBarState = (overrides && overrides.filterBarState !== undefined) ? overrides.filterBarState : this._currentFilterBarState;
        var urlState = filterBarStateToUrl(filterBarState);
        if (sortBy && sortBy !== DEFAULT_SORT) urlState.sort = sortBy;
        if (searchTerm) urlState.find = searchTerm;
        writeFiltersToUrl(urlState, URL_SCHEMA);
    }

    maxPage=(data,N)=>{
        return Math.ceil(data.length / N);
    }

    filterDataByIndustry=(data,industry)=>{
        if(!industry) return data;
        return data.filter(item=>{
            return (item.industries.includes(industry));
        });
    }

    // Clear All chip — reset filters AND sort so the URL goes clean.
    onClearAll = (clearedFilters) => {
        this._currentFilterBarState = clearedFilters;
        var data = this.state.dataCopy.slice();
        if (this.props.industry) data = this.filterDataByIndustry(data, this.props.industry);
        data = this.sortData(data, DEFAULT_SORT);
        let filteredDataCopy = cloneData(data);
        if (this.state.searchTerm && this.state.searchTerm.trim() !== '') {
            data = data.filter(p => this.matchesSearch(p, this.state.searchTerm));
        }
        this.setState({
            pagedData: data.slice(0, this.state.N),
            data: data,
            filteredDataCopy: filteredDataCopy,
            page: 1,
            maxPage: this.maxPage(data, this.state.N),
            sortBy: DEFAULT_SORT,
            urlVersion: (this.state.urlVersion || 0) + 1,
            showLoader: false
        });
        this.syncUrl({ filterBarState: clearedFilters, sortBy: DEFAULT_SORT });
    }

    onFiltersChange = (filters) => {
        this._currentFilterBarState = filters;
        var allProducts = this.state.dataCopy;
        var filtered = allProducts.filter(function (p) {
            return productMatchesFilters(p, filters);
        });

        if(this.state.sortBy){
            filtered = this.sortData(filtered,this.state.sortBy);
        }
        let filteredDataCopy=cloneData(filtered);
        if(this.state.searchTerm && this.state.searchTerm.trim() !==''){
            filtered = filtered.filter(product => this.matchesSearch(product, this.state.searchTerm));
        }
        var paged=filtered.slice(0,this.state.N);
        let maxPage=this.maxPage(filtered,this.state.N);

        this.setState({
            pagedData: paged,
            data: filtered,
            filteredDataCopy: filteredDataCopy,
            page:1,
            maxPage:maxPage,
            showLoader: false
        },()=>{
            this.throttleScroll = false;
        });
        this.syncUrl({ filterBarState: filters });
    }

    uniqueById = (arr) => {
        return [...new Map(arr.map(item => [item.id, item])).values()];
    }

    onLike = (e,item) => {
        e.preventDefault();
        e.stopPropagation();
        document.dispatchEvent(new CustomEvent('favorite-add', { detail: { itemType: 'Fabric', sku: item.sku, name: item.name, image: this.props.baseImageUrl + '/' + item.image + '?w=500', collection: item.collection || '', link: window.location.pathname, price: item.price || '' } }));
    }

    sortData=(data,sortBy)=>{
        let params = sortBy.split("|");
        let sortField = params[0];
        let sortDirection = params[1];
        let sortedData = sortByProperty(data, sortField, sortDirection);
        return sortedData;
    }

    onSortChange = (sortBy) => {
        let val = Array.isArray(sortBy) ? sortBy[0] : sortBy;
        if (!val) return;
        let params = val.split("|");
        let sortField = params[0];
        let sortDirection = params[1];
        let sortedData = sortByProperty(this.state.data, sortField, sortDirection);
        let pagedData=sortedData.slice(0,this.state.N);
        this.setState({ data: sortedData,
            filteredDataCopy: sortedData,
            pagedData: pagedData,
            sortBy:val
        });
        this.syncUrl({ sortBy: val });
    }

    rebind=()=>{
        //this.galleryGrid.classList.add('lazy-image-disabled');
        let nextPage=this.state.page+1;
        let pagedData=this.state.data.slice(0,this.state.N*nextPage);
        console.log("Rebind:",nextPage,pagedData.length);
        this.setState({
            pagedData: pagedData,
            page: nextPage,
            showLoader: false
        },()=>{
            this.throttleScroll = false;
        });
        
    }

    onScroll() {
        super.onScroll();
        if (!this.throttleScroll) {
            this.throttleScroll = true;
            if (this.state.page < this.state.maxPage) {
                this.setState({ showLoader: true },()=>{
                    setTimeout(() => {
                        this.rebind();
                    }, 1000);
                });
            }
        }
    }

    onSubmitSearch = (value) => {
        console.log("Search submitted from Gallery:", value);
        // Implement search logic here based on the submitted value
        // For example, you might want to filter this.state.dataCopy and then update this.state.data
        /*this.setState((prevState) => {
            const nextState = { ...prevState, searchQuery: value };
            if (typeof this.props.onSearchSubmit === "function") {
                this.props.onSearchSubmit(nextState);     */          
                    
        var trimmed = value ? value.trim() : '';
        if(!trimmed){
            let data=this.state.filteredDataCopy;
            let pagedData=data.slice(0,this.state.N);
            this.setState({
                pagedData: pagedData,
                data: data,
                page:1,
                maxPage:this.maxPage(pagedData,this.state.N),
                searchTerm:''
            });
            this.syncUrl({ searchTerm: '' });
            return;
        }else{
            let data = this.state.filteredDataCopy;
            let filtered = data.filter(product => this.matchesSearch(product, trimmed));
            let pagedData=filtered.slice(0,this.state.N);
            this.setState({
                data: filtered,
                pagedData: pagedData,
                page:1,
                maxPage:this.maxPage(filtered,this.state.N),
                searchTerm:trimmed
            });
            this.syncUrl({ searchTerm: trimmed });
        }
    }

    matchesSearch(product, query) {
        if (!query) return true;

        const q = query.trim().toLowerCase();
        if (!q) return true;

        const sku = (product.sku || "").toLowerCase();
        const name = (product.name || "").toLowerCase();

        // ---- SKU matching ----
        let skuMatch = false;

        if (q.length === 1) {
            // starts with letter OR ends with "-<letter>"
            skuMatch =
                sku.startsWith(q) ||
                sku.endsWith("-" + q);
        } else {
            skuMatch = sku.indexOf(q) !== -1;
        }

        // ---- Name matching ----
        let nameMatch = false;

        if (q.length > 1) {
            nameMatch = name.indexOf(q) !== -1;
        }

        return skuMatch || nameMatch;
    }


}

export class FabricGalleryComponent extends BaseGalleryComponent {

    render() {

        return <Gallery
            data={this.state.data}
            pagedData={this.state.pagedData}
            onFiltersChange={this.onFiltersChange}
            baseImageUrl={this.props.baseImageUrl}
            onLike={this.onLike}
            onSortChange={this.onSortChange}
            location={this.props.location}
            industry={this.props.industry}
            showLoader={this.state.showLoader}
            onSubmitSearch={this.onSubmitSearch}
            urlVersion={this.state.urlVersion}
            currentSort={this.state.sortBy}
            searchTerm={this.state.searchTerm}
        >
            <FabricFiltersBar
                key={"ffb-" + this.state.urlVersion}
                onFiltersChange={this.onFiltersChange}
                onClearAll={this.onClearAll}
                filters={this.props.filters}
                initialFilters={this.state.initialFilterBarState}
            />
        </Gallery>
    }
}



